import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import IssuingOfficeService from "@services/IssuingOfficeService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";

const ShowIssuingOffice = ({ issuingOffice }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [issuingOfficeData, setIssuingOfficeData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      IssuingOfficeService.find(issuingOffice.id).then((response) => {
        setIssuingOfficeData(response.data.data);
      });
  }, [issuingOffice.id, showModal]);

  return (
    <PermissionHandler permission={"view_issuing_offices"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={issuingOfficeData.name} />
          <RowDetails label={t("nameEng")} value={issuingOfficeData.name_eng} />
          <RowDetails
            label={t("description")}
            value={issuingOfficeData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowIssuingOffice;
